import React from "react";
import {Col, Container, Image, Row} from "react-bootstrap";
import {faClock, faFolderUser, faGraduationCap, faHashtag, faTerminal, faUser} from "@fortawesome/pro-solid-svg-icons";
import {Get} from "./request";
import screens from "../screens";
import IconTitle, {IconTitles} from "./iconTitle";
import ScreenComponent from "./screenComponent";
import {withRouter} from "react-router-dom";
import parse from "react-html-parser";
import {faUserCheck} from "@fortawesome/sharp-solid-svg-icons";

class Student extends ScreenComponent {
    constructor(props) {
        super(props);

        this.state = {user: {}};
    }

    async componentDidMount() {
        super.componentDidMount();

        const {body} = await Get(`/v1/extranet/student/${screens.Dashboard}`);

        this.setState({
            user: body
        });
    }

    render() {

        let header = [
            {icon: faGraduationCap, content: this.state.user.DiplomeLibelle, classIcon: 'ml-1'},
            {icon: faTerminal, content: this.state.user.NiveauCoursLibelle, classIcon: 'ml-1'},
            {icon: faClock, content: this.state.user.Modalite, classIcon: 'ml-1'},
        ];

        if (!(!!this.props.simplify) && (this.state.user.AnneeAcademiqueValeur?.includes(new Date().getFullYear()) ?? false)) {
            if (this.state.user.GestionnairesAdministratifs != null) header.push({icon: faFolderUser, content: parse("<small><u>Gestionnaire(s) administratif(s)</u></small> : " + this.state.user.GestionnairesAdministratifs)});
            if (this.state.user.Coordinateurs != null) header.push({icon: faUserCheck, content: parse("<small><u>Coordinateur(s)</u></small> : " + this.state.user.Coordinateurs)});
        }

        return (
            <section>
                <Container>
                    <Row className="align-items-center">
                        <Col xs={4} md={3} xl={2}>
                            <div>
                                <div className="rounded">
                                    <Image src={this.state.user.PersonnePhoto} alt="PhotoEtudiant"/>
                                </div>
                            </div>
                        </Col>
                        <Col>
                            <IconTitle type="h4" icon={faUser}
                                       classContent="ml-2"
                                       content={this.state.user.PersonnePrenom + " " + this.state.user.PersonneNom}/>
                            <IconTitle type="h5" icon={faHashtag}
                                       classContent="ml-3"
                                       content={this.state.user.EtudiantMatricule}/>
                            <hr/>

                            <IconTitles titles={header}/>

                        </Col>
                    </Row>
                </Container>
            </section>
        );
    }
}

export default withRouter(Student);